/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable no-unused-vars */
/** @jsxRuntime classic */
/** @jsx jsx */
import React, {
  Component,
  useEffect,
  useLayoutEffect,
  useState,
  useRef,
  Fragment,
} from "react";
import { css, jsx } from "@emotion/react";
import _ from "lodash";
import config from "config.js";
import log from "common/log.js";
import ReactHtmlParser, {
  processNodes,
  convertNodeToElement,
  htmlparser2,
} from "react-html-parser";
const axios = require("axios");

function findCommonElements(arr1, arr2) {
  return arr1.some((item) => arr2.includes(item));
}

function emailIsValid(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export default class BaseCustomerForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      owner: 1,
      name: "",
      phone: "",
      email: "",
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleFormSubmit = () => {
    let $this = this;
    let hasAlerted = false;
    let ok = true;
    let formData = {
      owner: $this.state.owner,
      name: $this.state.name,
      phone: $this.state.phone,
      email: $this.state.email,
    };

    // Check name
    if (formData.name === "") {
      ok = false;
    }

    // Check mail
    if (formData.email === "") {
      ok = false;
    } else {
      if (emailIsValid(formData.email) === false) {
        ok = false;
      }
    }

    // Check phone
    if (formData.phone === "") {
      ok = false;
    } else {
      let vnf_regex = /((09|03|07|08|05)+([0-9]{8})\b)/g;
      let mobile = formData.phone;
      let mobile_vn;
      let is_mobile_ok = false;

      if (mobile.startsWith("+84")) {
        mobile_vn = "0" + mobile.substring(3);
      } else if (mobile.startsWith("84")) {
        mobile_vn = "0" + mobile.substring(2);
      } else if (mobile.startsWith("0") && mobile.length === 10) {
        mobile_vn = mobile;
      }

      formData.phone = mobile_vn;
      mobile = mobile_vn;

      if (mobile_vn !== "") {
        if (vnf_regex.test(mobile) === false) {
          hasAlerted = true;
          alert("Số điện thoại của bạn không đúng định dạng!");
        } else {
          is_mobile_ok = true;
        }
      } else {
        hasAlerted = true;
        alert("Bạn chưa điền số điện thoại!");
      }

      if (is_mobile_ok === false) {
        ok = false;
      }
    }

    if (ok === true) {
      axios
        .post(config.api.customer_form, formData)
        .then(function (response) {
          if (response.data.data) {
            alert(
              "Xin cảm ơn. Bạn sẽ được UB liên hệ trong thời gian sớm nhất."
            );
          }
          // log(response);
          if (response.data.error) {
            if (response.data.error.message.includes("Duplicate"))
              alert(
                "Xin cảm ơn. Số điện thoại của bạn đã đăng ký trước đó. Bạn sẽ được UB liên hệ trong thời gian sớm nhất."
              );
          }
        })
        .catch(function (error) {
          // alert("Xin hãy nhập đúng thông tin và thử lại.");
          log(error);
          // if (error.response.data.error) {
          //   if (error.response.data.error.message.includes("Duplicate"))
          //     alert(
          //       "Xin cảm ơn. Số điện thoại của bạn đã đăng ký trước đó. Bạn sẽ được UB liên hệ trong thời gian sớm nhất."
          //     );
          // }
        })
        .then(function () {});
    } else {
      if (hasAlerted === false) {
        alert("Mời bạn nhập đầy đủ thông tin trên form.");
      }
    }
  };

  render() {
    return <React.Fragment></React.Fragment>;
  }
}
